import React, { Component } from "react";
import { connect } from "react-redux";
import LegacyMenu from "./Menu/LegacyMenu";
import { sidebarToggle } from "../../actions/globalAction";
import { ReactComponent as ArrowIcon } from "../../assets/svg/chevron.svg";
import "./Sidebar.scss";
import Menu from "./Menu/Menu";

class Sidebar extends Component {
    constructor(props) {
        super(props);
        this.state = { sidebarExpanded: false };
    }

    render() {
        return (
            <section id="sidebar" className={`sidebar skiptranslate ${this.props.sidebarExpanded ? "expanded" : "collapsed"}`}>
                <div className="sidebar-toggle" onClick={this.props.sidebarToggle}>
                    <div className={`sidebar-toggle-button `}>
                        <ArrowIcon
                            className={`arrow ${this.props.sidebarExpanded ? "left" : "right"} ${this.props.activeModule && this.props.activeModule} `}
                        />
                    </div>
                </div>
                <div className="sidebar-wrapper" id="sidebar-wrapper">
                    <Menu
                        pathname={this.props.pathname}
                        current_view_filter={this.props.current_view_filter}
                        filters={this.props.filters}
                        company={this.props.company}
                        teams={this.props.teamsIBelongToOptions}
                        sidebarExpanded={this.props.sidebarExpanded}
                        packageObj={this.props.packageObj}
                        sidebarToggle={this.props.sidebarToggle}
                        companyPic={this.props.companyPic}
                        command_center={this.props.command_center}
                        user={this.props.user}
                        // showGettingStarted={this.props.showGettingStarted}
                    />
                </div>
            </section>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        sidebarExpanded: state.globalReducer.sidebarExpanded,
        packageObj: state.globalReducer.packageObj,
        companyPic: state.globalReducer.company.company_logo_v2,
        command_center: state.globalReducer.command_center,
        user: state.globalReducer.user,
        showGettingStarted: state.globalReducer.showGettingStarted,
        activeModule: state.sidebarReducer.activeModule,
    };
};

function mapDispatchToProps(dispatch) {
    return {
        sidebarToggle: () => dispatch(sidebarToggle()),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
